import { useEffect, useState } from 'react';

import { COLLAPSE_STATE_CHANGED, collapseEventTarget } from 'features/shared/collapseStorage';

import { SMART_RATE_FAQ_SECTION_SCOPE } from './SmartRateFaqs.constants';

export const useSmartRateFaqOpenState = sectionId => {
  const [isOpen, setIsOpenState] = useState(false);

  useEffect(() => {
    const handleChange = event => {
      const { storageKey: scope, sectionId: id, isOpen: value } = event.detail;
      if (scope === SMART_RATE_FAQ_SECTION_SCOPE && id === sectionId) {
        setIsOpenState(value);
      }
    };
    collapseEventTarget.addEventListener(COLLAPSE_STATE_CHANGED, handleChange);
    return () => collapseEventTarget.removeEventListener(COLLAPSE_STATE_CHANGED, handleChange);
  }, [sectionId]);

  const setIsOpen = updater => {
    setIsOpenState(prev => (typeof updater === 'function' ? updater(prev) : updater));
  };

  return [isOpen, setIsOpen];
};
